import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * TenantInterceptor - Adds tenant-related headers to API requests
 * Can be used to add X-Tenant-Id header if needed by the backend
 */
@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add tenant-related headers if needed
    // For now, just pass through
    // You can extract tenant from MSAL token claims if needed
    return next.handle(request);
  }
}
